import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-angular-maven',
	templateUrl:'./AngularMavenPluginPage.html',
	styles: [],
	styleUrls:['./AngularMavenPluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		MarkdownComponent,
],
	standalone:true
})
export class AngularMavenPluginPage
{
	mdContent_66 = `\`\`\`xml
<plugin>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>angular-maven-plugin</artifactId>
  <version>2.0.0-SNAPSHOT</version>
  <executions>
    <execution>
      <goals><goal>build</goal></goals>
    </execution>
  </executions>
</plugin>
\`\`\``;
	mdContent_67 = `\`\`\`java
<plugin>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>angular-maven-plugin</artifactId>
  <configuration>
    <ensureToolchain>true</ensureToolchain>
    <installDependencies>true</installDependencies>
    <buildAngular>true</buildAngular>
    <buildDockerImage>true</buildDockerImage>
    <dockerImageName>my-app:latest</dockerImageName>
  </configuration>
</plugin>
\`\`\``;
	mdContent_68 = `\`\`\`java
<plugin>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>angular-maven-plugin</artifactId>
  <configuration>
    <buildAngular>true</buildAngular>
    <buildDockerImage>true</buildDockerImage>
    <nginxHttps>true</nginxHttps>
    <nginxServerName>example.com</nginxServerName>
    <nginxSslCertificate>/etc/nginx/ssl/cert.pem</nginxSslCertificate>
    <nginxSslCertificateKey>/etc/nginx/ssl/key.pem</nginxSslCertificateKey>
    <nginxCustomEntries>
      <entry>client_max_body_size 50m;</entry>
    </nginxCustomEntries>
  </configuration>
</plugin>
\`\`\``;
	mdContent_69 = `\`\`\`java
<plugin>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>angular-maven-plugin</artifactId>
  <configuration>
    <appClasses>
      <appClass>com.myapp.MyAngularApp</appClass>
    </appClasses>
    <classpathScope>compile</classpathScope>
  </configuration>
</plugin>
\`\`\``;
	mdContent_70 = `\`\`\`java
<!-- In your pom.xml <build><plugins> section -->
<plugin>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>angular-maven-plugin</artifactId>
  <configuration>
    <installDependencies>true</installDependencies>
    <ensureToolchain>true</ensureToolchain>
    <buildAngular>true</buildAngular>
    <!-- Optional: build a Docker image -->
    <buildDockerImage>true</buildDockerImage>
  </configuration>
</plugin>
\`\`\``;
}
